import React from 'react'
import PropTypes from 'prop-types'
import {MinusCircleOutlined, PlusCircleOutlined} from '@ant-design/icons'

import './index.css'

class NumberPicker extends React.Component {
  change = (direction) => {
    let {value} = {...this.props}

    switch (direction) {
      case 'PREV':
        if (this.canGoPrev()) {
          value -= 1
        }
        break
      case 'NEXT':
        if (this.canGoNext()) {
          value += 1
        }
      // no default
    }

    if (value !== this.props.value) {
      return this.props.onChange(value)
    }
  }

  canGoNext = () => {
    if (typeof this.props.max !== 'number') return true
    return (this.props.value + 1) <= this.props.max
  }

  canGoPrev = () => {
    if (typeof this.props.min !== 'number') return true
    return (this.props.value - 1) >= this.props.min
  }

  render() {
    return (
      <div className="number-picker">
        <div
          onClick={this.change.bind(this, 'PREV')}
          className={[
            'navigate',
            'previous',
            this.canGoPrev() ? '' : ' disabled',
          ].join(' ').trim()}
        >
          <MinusCircleOutlined />
        </div>

        <div className="value">
          {this.props.value}
        </div>

        <div
          onClick={this.change.bind(this, 'NEXT')}
          className={[
            'navigate',
            'next',
            this.canGoNext() ? '' : ' disabled',
          ].join(' ').trim()}
        >
          <PlusCircleOutlined />
        </div>
      </div>
    )
  }
}

NumberPicker.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
}

NumberPicker.defaultProps = {
  min: 0,
}

export default NumberPicker
